import { Platform } from '@ionic/angular';
import { NgModule, NgZone } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Browser, AuthService } from 'ionic-appauth-custom';
import { CapacitorBrowser, CapacitorSecureStorage } from 'ionic-appauth-custom/lib/capacitor';

import { NgHttpService } from './ng-http.service';
import { authFactory } from './factories';
import { AppLinksService} from '../../app-links.service';
import {Requestor, StorageBackend} from '@openid/appauth';

@NgModule({
  imports: [
    CommonModule
  ],
  providers: [
    {
      provide: StorageBackend,
      useClass: CapacitorSecureStorage
    },
    {
      provide: Requestor,
      useClass: NgHttpService
    },
    {
      provide: Browser,
      useClass: CapacitorBrowser
    },
    {
      provide: AuthService,
      useFactory : authFactory,
      deps: [Platform, NgZone, Requestor, Browser, StorageBackend, AppLinksService]
    }
  ]
})
export class CoreModule { }
